import type { PendingRunAction } from '../runTypes';

function key(shortId: string) {
  return `x9_run_pending_${shortId}`;
}

export function loadPendingAction(shortId: string): PendingRunAction | null {
  try {
    const raw = sessionStorage.getItem(key(shortId));
    if (!raw) return null;
    const parsed = JSON.parse(raw) as PendingRunAction;
    if (!parsed?.actionId || !parsed.action?.type) return null;
    return parsed;
  } catch {
    return null;
  }
}

export function savePendingAction(shortId: string, pending: PendingRunAction): void {
  try {
    sessionStorage.setItem(key(shortId), JSON.stringify(pending));
  } catch {
    // Quota / private mode — still send now; Retry may not survive reload.
  }
}

export function clearPendingAction(shortId: string): void {
  try {
    sessionStorage.removeItem(key(shortId));
  } catch {
    // ignore
  }
}
